import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AgentPortfolioSummary } from './agent-summary.types';

@Injectable({ providedIn: 'root' })
export class AgentSummaryService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/agent/portfolio-summary`;

  /** Portfolio summary for the agent dashboard (intake over last `days` days). */
  get(days = 30): Observable<AgentPortfolioSummary> {
    return this.http.get<AgentPortfolioSummary>(`${this.base}/`, { params: { days } });
  }
}
